import DefaultLayout from '../../components/layouts/default-layout/DefaultLayout';
import { Route, useSearchParams } from 'react-router-dom';
import LeitnerBoxList from '../../components/leitner/leitner-box-list/LeitnerBoxList';
import AddLeitnerBox from '../../leitner/add-leitner-box/AddLeitnerBox';
import AddWordCard from '../../leitner/add-word-card/AddWordCard';
import WordCardDetails from '../../leitner/word-card-details/WordCardDetails';
import WordBookMarkedList from '../../leitner/word-book-marked-list/WordBookMarkedList';
import LeitnerBoxInformation from '../../leitner/leitner-box-information/LeitnerBoxInformation';
import WordList from '../../leitner/word-list/WordList';
import WordView from '../../leitner/word-view/WordView';
export default function LeitnerRoute() {

    const [searchParams] = useSearchParams();
    return <>
        <Route element={<DefaultLayout showContactUs={false} backUri={"/StudentExtraCurricular?statusPage=0"} title={"جعبه لایتنر"} />}>
            <Route path="/LeitnerBoxs" element={<LeitnerBoxList showActions={false} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBoxs"} title={"جعبه لایتنر اختصاصی"} />}>
            <Route path="/CustomBoxs" element={<LeitnerBoxList showActions={true} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBoxs"} title={"جعبه لایتنر"} />}>
            <Route path="/LeitnerBox" element={<LeitnerBoxInformation boxId={searchParams.get('boxId')} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBox?boxId=" + searchParams.get('boxId')} title={"مطالعه کلمات"} />}>
            <Route path="/LeitnerBoxCard" element={<WordCardDetails boxId={searchParams.get('boxId')} config={{ showActions: true }} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBox?boxId=" + searchParams.get('boxId')} title={"افزودن عبارت"} />}>
            <Route path="/LeitnerBoxAddCard" element={<AddWordCard boxId={searchParams.get('boxId')} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBox?boxId=" + searchParams.get('boxId')} title={"کلمات نشان شده"} />}>
            <Route path="/LeitnerBoxBookMarks" element={<WordBookMarkedList boxId={searchParams.get('boxId')} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerBox?boxId=" + searchParams.get('boxId')} title={"لیست کلمات"} />}>
            <Route path="/LeitnerFlashCards" element={<WordList boxId={searchParams.get('boxId')} />} />
        </Route>


        <Route element={<DefaultLayout showContactUs={false} backUri={"LeitnerFlashCards?boxId=" + searchParams.get('boxId')} title={"مطالعه کلمات"} />}>
            <Route path="/LeitnerWordView" element={<WordView boxId={searchParams.get('boxId')} skip={searchParams.get('skip')} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"/CustomBoxs"} title={"ساخت جعبه لایتنر"} />}>
            <Route path="/CreateLeitner" element={<AddLeitnerBox />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} backUri={"/CustomBoxs"} title={" جعبه لایتنر"} />}>
            <Route path="/CustomBoxInformation" element={<LeitnerBoxInformation boxId={searchParams.get('boxId')} />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/StudentExtraCurricular"} title={"جعبه لایتنر"} />}>
            <Route path="/LeitnerBoxInformation" element={<LeitnerBoxInformation />} />
        </Route>
    </>
}